<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-dinopop">
      <div class="px-3 col-3 p-0">
        <div class="heading-dinopop">{{ $t("result.round") }}</div>
        <div class="text-subhead-dinopop">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinopop">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-dinopop">
          {{ data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinopop">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-dinopop">
          {{ winlose | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinopop">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-dinopop">
          {{ balance | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-dinopop pt-3">
      <div class="text-game-dinopop">Dino Pops</div>
      <div class="text-subgame-dinopop">{{ $t("dinopop.name") }}</div>
      <div class="text-subgame-dinopop"></div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <!-- <section v-if="result.state === 'BONUSGAME'"></section>
      <section v-else> -->
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="isFreespin || isBonus" class="fas fa-caret-left arrow-side-dinopop" @click="delCount()"></i>
        </div>
        <div class="all-table-dinopop container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in newReel[0]" :key="index">
                <td v-for="(col, i) in newReel" :key="`${index}${i}`" class="p-0"
                  style="position: relative;text-align: center;">
                  <img class="icon-symbol" :src="require(`../../assets/resultGame/dinopop/symbol_${col[index]
                    }.png`)
                    " alt="" />
                  <section v-if="col[index][0] === 11">
                    <span
                      style="position: absolute;top: 60%;left: 40%;transform: translate(-50%, -50%);font-size: large; color: yellow; -webkit-text-stroke: 1px black;">{{
                        convertNumberAbbreviated(newBonusReel[i][index][0]) }}</span>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-dinopop" @click="addCount()"></i>
        </div>
      </div>
      <div v-if="isBonus" class="text-subgame-dinopop mb-1">
        {{ $t("result.bonus") }}
      </div>
      <div v-else-if="result.freeSpin.round" class="text-subgame-dinopop mb-1">
        {{
          $t("result.freespin") +
          " " +
          result.freeSpin.round +
          "/" +
          result.freeSpin.totalRound
        }}
      </div>
      <div v-if="winlose > 0">
        <div class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3">
            {{ $t("result.detail") }}
          </div>
          <hr class="line col-3" />
        </div>
        <div v-if="result.featureBuy" class="col-12 justify-content-center d-flex flex-row">
          <div class="text-subgame-dinopop mb-1">{{ $t("featurebuy.title") }}</div>
        </div>
        <div class="col-12 justify-content-center d-flex flex-row mt-4">
          <div class="bet-box-dinopop p-2 px-3">
            <div class="bet-warpper item" v-for="(block, i) in winnings" :key="i">
              <div class="d-flex item justify-content-between px-1 mb-2">
                <div class="bet-wrapper-dinopop item">
                  <div class="d-flex justify-content-start bet-wrapper-dinopop item">
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 yellow">
                        {{ `Line ${block.line + 1}` }}
                      </p>
                    </div>
                    <img class="icon-detail-hcl" :src="require(`../../assets/resultGame/dinopop/symbol_${block.symbol
                      }.png`)
                      " alt="" />
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 yellow">
                        {{ `${block.count} ` + $t("result.kind") }}
                      </p>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">{{ currency }} {{ block.amount | currencyFormatter }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bet-warpper item" v-if="result.winShowsCount === 0">
              <div class="d-flex justify-content-between mt-5">
                <div class="bet-wrapper-dinopop item align-content-center d-flex">
                  <div class="d-flex justify-content-center bet-wrapper-dinopop item align-content-center p-3">
                    <p class="my-1 red">{{ "No Winnings" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </section> -->
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-dinopop",
  props: {
    data: Object,
  },
  data() {
    // eslint-disable-next-line
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      currency: this.data.currency ? (this.data.detail.isCoin ? 'AMS' : this.data.currency) : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFirst: (this.data.detail.state === 'SPIN'),
      isLast: (this.data.detail.isEndRound),
      newReel: [],
      newBonusReel: [],
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header"
      )[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isBonus = result.state === 'BONUSGAME'
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;
      this.newReel = await this.mapTable(result.reels);
      this.newBonusReel = await this.mapTable(result.bonusReels);
      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
    convertNumberAbbreviated(val) {
      let suffix = ""
      if (val > 999999) {
        val = val / 1000000
        suffix = "M"
      } else if (val > 9999) {
        val = val / 1000
        suffix = "K"
      }
      return String(this.APPLY_EPSILON(val) + suffix);
    },
    getBaseForEPSILON(num) {
      let base = 100;
      if (num > -10 && num < 10) {
        base = 1000
      } else if (num >= 10 && num < 10000) {
        base = 100
      } else if (num >= 10000 && num < 1000000) {
        base = 10
      } else {
        base = 100
      }
      return base;
    },
    APPLY_EPSILON(num) {
      return (Math.round(((num) + Number.EPSILON) * this.getBaseForEPSILON(num)) / this.getBaseForEPSILON(num))
    }
  },
};
</script>

<style scoped>
.bonus-wining {
  width: 230px;
  height: 70px;
  background-color: #1eaca6;
  border-radius: 14px;
  color: #ffe463;
}

.icon-detail-hcl {
  width: 90px;
  padding: 10px;
  height: 90px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-dinopop {
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box-dinopop {
  background: #1A5350;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-dinopop .item {
  color: #fff;
  background: #1eaca6;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #1eaca6;
}

.bet-box-dinopop .bet-wrapper-dinopop:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-dinopop,
.result-wrapper {
  font-size: 35px;
}

.header-dinopop {
  background: #1eaca6;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-dinopop {
  color: #ffe463;
  text-align: center;
}

.content-result-dinopop {
  background: #0f5350;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-dinopop {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-dinopop {
  text-shadow: 0px 0px 20px #ffe463;
  color: #ffe463;
  font-weight: bold;
  font-size: 25px;
  text-align: center;
}

.text-subhead-dinopop {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame-dinopop {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #ffe463;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #ffe463;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box-dinopop {
  min-width: 600px;
  max-width: auto;
}

.all-table-dinopop {
  /* background: url("~@/assets/resultGame/dinopop/dinopop_frame.png") no-repeat; */
  background-size: 770px 470px;
  width: 770px;
  height: 470px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  padding-top: 20px;
}

@media screen and (max-width: 1030px) {
  .all-table-dinopop {
    background-size: 770px 470px;
    width: 770px;
    height: 470px;
    padding-top: 20px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-dinopop {
    font-size: 60px;
  }

  .bet-box-dinopop {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-dinopop,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {
  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-dinopop,
  .result-wrapper {
    font-size: 33px;
  }
}

.line {
  background-color: #ffe463;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.yellow {
  color: #ffe463;
  font-size: 5vw;
}

@media screen and (max-width: 770px) {
  .heading-dinopop {
    font-size: 18px;
  }

  .all-table-dinopop {
    background-size: 540px 330px;
    width: 540px;
    height: 330px;
    padding-top: 20px;
  }

  .text-subhead-dinopop {
    font-size: 18px;
  }

  .arrow-side-dinopop {
    font-size: 50px;
  }

  .bet-box-dinopop {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #ffe463;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-dinopop {
    font-size: 12px;
  }

  .all-table-dinopop {
    background-size: 305px 180px;
    width: 305px;
    height: 180px;
    padding-top: 10px;
  }

  .text-subhead-dinopop {
    font-size: 14px;
  }

  .bet-box-dinopop {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-dinopop,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-hcl {
    width: 60px;
    height: 60px;
    padding: 5px;
  }

  .contianer-center-parent {
    position: relative;
    text-align: center;
  }

  .bonus-text-inner {
    position: absolute;
    top: 60%;
    left: 40%;
    transform: translate(-50%, -50%);
  }
}
</style>
